import React from 'react';

import { Modal } from 'antd-v5';
import { FormattedHTMLMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from 'scouting-ui/lib';

import { isEventsLoadingSel } from '@modules/calendar/duck/selectors';
import { eventToDeleteSel } from '@modules/events/duck/selectorsTyped';
import { setEventToDelete } from '@modules/events/duck/slice';
import { deleteEventReq } from '@shared';

export const ConfirmDeleteEventModal = () => {
  const dispatch = useDispatch();
  const eventToDelete = useSelector(eventToDeleteSel);
  const isEventsLoading = useSelector(isEventsLoadingSel);

  const handleConfirmDelete = () => {
    dispatch(deleteEventReq(eventToDelete?.id));
  };

  return (
    <Modal
      closable={false}
      cancelButtonProps={{ type: 'default', loading: isEventsLoading }}
      cancelText="Cancel"
      okText="Delete"
      onCancel={() => dispatch(setEventToDelete(undefined))}
      onOk={handleConfirmDelete}
      open={!!eventToDelete}
      title="Confirm"
      okButtonProps={{ loading: isEventsLoading }}
    >
      <Text>
        <FormattedHTMLMessage
          id="events.confirmDeleteModal.content"
          values={{ name: eventToDelete?.name }}
        />
      </Text>
    </Modal>
  );
};
